import script from "./ManageUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageUsers.vue?vue&type=script&setup=true&lang=js"

import "./ManageUsers.vue?vue&type=style&index=0&id=0a345860&lang=css"

const __exports__ = script;

export default __exports__